import { withLayoutProps } from '@/utils/withLayoutProps';

import { StyledBody, StyledCard, StyledHeader } from './styles';

import { Paragraph } from '../Paragraph';

import type { ReactNode } from 'react';

interface CardWithHeaderProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

export const CardWithHeader = withLayoutProps(({ title, subtitle, children, ...props }: CardWithHeaderProps) => (
  <StyledCard {...props}>
    <StyledHeader>
      <Paragraph weight={700} size="2xl" color="white">
        {title}
      </Paragraph>
      {subtitle && (
        <Paragraph color="white" weight={500} size="sm">
          {subtitle}
        </Paragraph>
      )}
    </StyledHeader>
    <StyledBody>{children}</StyledBody>
  </StyledCard>
));
